import {DateTimeField} from '../common/DateTimeField'
import {useStore} from '../../store'

interface EditorDatePickerProps {
  type: 'date' | 'datetime'
  label?: string
  variant?: 'standard' | 'filled' | 'outlined'
  value: Date | string
  name: string
  onChange(name: string, date: Date): void
  error?: boolean
  errMsg?: string
  maxDate?: Date
  minDate?: Date
  maxTime?: Date
  minTime?: Date
}

const EditorDatePicker = ({
  value,
  label,
  name,
  onChange,
  minDate,
  maxDate,
  minTime,
  maxTime,
}: EditorDatePickerProps) => {
  const {week} = useStore()
  return (
    <DateTimeField
      id={`editor-${name}`}
      label={label || ''}
      value={value}
      onChange={(date) => onChange(name, date)}
      weekStartOn={week!.weekStartOn}
      minDate={minDate}
      maxDate={maxDate}
      minTime={minTime}
      maxTime={maxTime}
    />
  )
}

EditorDatePicker.defaultProps = {
  type: 'datetime',
  variant: 'outlined',
}
export {EditorDatePicker}
